import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";

interface DocumentPreviewProps {
  file: File;
  onClose?: () => void;
}

export default function DocumentUploadPreview({
  file,
  onClose,
}: DocumentPreviewProps) {
  return (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          fontSize: "small",
        }}
      >
        {file.name}
      </Typography>
      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "white",
            padding: 0,
            ml: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
}
